// extracted by mini-css-extract-plugin
export default {"MachineSettingsPage":"MachineSettingsPage_MachineSettingsPage__zOKZi","pageRow":"MachineSettingsPage_pageRow__nDv9C"};